module.exports = {"slides":[{"children":[{"element":"Heading","children":"Chrome DevTools"},{"element":"Paragraph","children":"TODO: Presentation to be migrated"}]}]}


//////////////////
// WEBPACK FOOTER
// ./pages/talks/chrome-devtools/chrome-devtools.json
// module id = ./pages/talks/chrome-devtools/chrome-devtools.json
// module chunks = 11